import React, { useEffect, useMemo, useRef, useState } from "react";
import { Link } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";

import {
  faHandshake,
  faPalette,
  faBriefcase,
  faCircleInfo,
  faChevronDown,
  faFileAlt,
  faShieldAlt,
  faHistory,
  faBookOpen,
  faUsers,
  faBuilding,
  faRocket,
  faCalendarAlt,
  faChartBar,
  faTasks,
  faFolderOpen,
  faComments,
} from "@fortawesome/free-solid-svg-icons";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import { ChevronRight, Database, Menu, X } from "lucide-react";

import logo_dark from "../../assets/new-images/simplifyte.com.png";
import Mobile_logo from "../../assets/new-images/simplifyte.com - Logo.png";

import logo_light from "../../assets/new-images/darkmodelogo.png";
import tasks_logo from "../../assets/new-images/tasks_icon.svg";
// import { ReactComponent as TasksIcon } from "../../assets/new-images/tasks_icon.svg";
import chat_logo from "../../assets/new-images/chat_icon.svg";
import team_icon from "../../assets/new-images/team_icon.svg";
import messaging_icon from "../../assets/new-images/chat_icon.svg";
import document_icon from "../../assets/new-images/docs_icon.svg";
import calender_icon from "../../assets/new-images/calender_icon.svg";
import dashboard_icon from "../../assets/new-images/dashboard_icon.svg";
import officehub_icon from "../../assets/new-images/officehub_icon.svg";
import BulkActionsvg from "../../assets/new-images/bulk-edit-svgrepo-com.svg";
import bulkUpload from "../../assets/new-images/bulk-upload.png";

import utilities_icon from "../../assets/new-images/utilities_icon.svg";
import customers_icon from "../../assets/new-images/customers_icon.svg";
// import FaviconImg from "../../../assets/new-images/Logo.ico";
// import FaviconImg from "../../assets/new-images/Logo";

const HeaderMenu = (props) => {
  const { navClass } = props;
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 992);
  const [isScrolled, setIsScrolled] = useState(false);
  const [titleText, setTitleText] = useState(""); // ✅ hovered hero title
  const [titleTick, setTitleTick] = useState(0); // ✅ animate title swap
  // ✅ which dropdown is open: "products" | "resources" | "company" | null
  const [activeMenu, setActiveMenu] = useState(null);
  const [isNavHidden, setIsNavHidden] = useState(false);
  const lastScrollY = useRef(0);
  const rafId = useRef(null);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [openCategory, setOpenCategory] = useState(null);

  const [desc, setDesc] = useState("");
  const [menuOpenTick, setMenuOpenTick] = useState(0);
  const [descTick, setDescTick] = useState(0);
  const [heroDesc, setHeroDesc] = useState("");
  const [heroDescTick, setHeroDescTick] = useState(0);
  // Hover intent timers
  const openT = useRef(null);
  const closeT = useRef(null);

  // ✅ CONTENT (same style across Products/Resources/Company)
  const MENUS = useMemo(
    () => ({
      // products: {
      //   kicker: "Products",
      //   title: "Explore Simplifyte",
      //   defaultDesc:
      //     "Everything your team needs to plan, execute, and deliver — without chaos.",
      //   items: [
      //     {
      //       key: "task_mgmt",
      //       title: "Task Management",
      //       sub: "Manage tasks with custom workflows.",
      //       to: "/features/task-management",
      //       heroDesc:
      //         "Make task management simple. Assign tasks, monitor progress, and keep everyone on the same page with ease.",
      //       heroTitle: "Task Management",
      //       icon: tasks_logo, // ✅ string url
      //       desc: "Manage tasks with custom workflows.",
      //     },
      //     {
      //       key: "team_collab",
      //       title: "Team Collaboration",
      //       sub: "Smarter handoffs with AI assignment.",
      //       heroDesc:
      //         "assign smarter, hand offs cleaner, accountability visible",
      //       heroTitle: "Team Collaboration",
      //       to: "/features/team-workflow",
      //       heroTitle: "Team Collaboration",
      //       icon: team_icon,
      //       desc: "Smarter handoffs with AI assignment.",
      //     },
      //     // {
      //     //   key: "messaging",
      //     //   title: "Messaging",
      //     //   heroDesc:
      //     //     "Stay connected with your team. Chat about tasks and projects in one place, so you never lose important details.",
      //     //   heroTitle: "Messaging",
      //     //   sub: "Chat that stays tied to tasks and files.",
      //     //   to: "/features/instant-messaging",
      //     //   heroTitle: "Messaging",
      //     //   icon: messaging_icon,
      //     //   desc: "Chat that stays tied to tasks and files.",
      //     // },
      //     {
      //       key: "documents",
      //       title: "Documents",
      //       heroDesc: "Find files instantly with structure that builds itself.",
      //       heroTitle: "Documents",
      //       sub: "Auto-organized search and folders.",
      //       to: "/features/document-management",
      //       icon: document_icon,
      //       desc: "Auto-organized search and folders.",
      //     },
      //     {
      //       key: "calendar",
      //       title: "Calendar",
      //       sub: "Sync meetings, events, and plans.",
      //       to: "/smartscheduling",
      //       icon: calender_icon,
      //       heroTitle: "Calendar",
      //       heroDesc:
      //         "Make scheduling easy. Keep your tasks, meetings, and events in sync, so you can stay ahead of your busy day",
      //       desc: "Sync meetings, events, and plans.",
      //     },
      //     {
      //       key: "dashboards",
      //       title: "Dashboards",
      //       heroDesc: "Your workflow, visualized—widgets, insights, clarity.",
      //       heroTitle: "Dashboards",
      //       sub: "Visualize progress with custom widgets.",
      //       to: "/features/custom-dashboard",
      //       icon: dashboard_icon,
      //       desc: "Visualize progress with custom widgets.",
      //     },
      //     {
      //       key: "office_hub",
      //       title: "Office Hub",
      //       sub: "Requests, attendance, and timesheets.",
      //       to: "/office-hub",
      //       heroDesc:
      //         "Keep your office running smoothly. Handle requests, track attendance, and manage timesheets, all in one convenient hub",
      //       heroTitle: "Office Hub",
      //       icon: officehub_icon,
      //       desc: "Requests, attendance, and timesheets.",
      //     },
      //     {
      //       key: "bulk_action",
      //       title: "Bulk Action",
      //       sub: "Bulk action Coherent simplified.",
      //       to: "/bulkActionsCoherent",
      //       icon: BulkActionsvg,
      //       heroDesc:
      //         "AI-enhanced bulk uploads auto-classify and validate data for Perfect integration.",
      //       desc: "Fast bulk uploads and data actions.",
      //     },
      //     // {
      //     //   key: "utilities",
      //     //   title: "Utilities 🚀",
      //     //   sub: "Fast bulk uploads and data actions.",
      //     //   to: "/utilities",
      //     //   icon: utilities_icon,
      //     //   heroDesc:
      //     //     "Super-fast bulk actions: upload, classify, validate—done.",
      //     //   heroTitle: "Utilities 🚀",
      //     //   desc: "Fast bulk uploads and data actions.",
      //     // },
      //   ],
      // },

      resources: {
        kicker: "Resources",
        title: "Explore Simplifyte",
        defaultDesc:
          "Guides, docs, and updates — built to help you move faster.",
        items: [
          {
            key: "docs",
            title: "Docs",
            sub: "Guides, setup, FAQs, and documentation.",
            heroDesc: "Everything needed to understand and use Simplifyte.",
            heroTitle: "Documentation",
            to: "/docs",
            icon: faBookOpen,
            desc: "Guides, setup, FAQs, and documentation.",
          },
          {
            key: "brand_kit",
            title: "Brand Kit",
            heroDesc: "Official assets and guidelines for consistent use.",
            heroTitle: "Brand Kit",
            sub: "Logos, colors, and usage guidelines.",
            to: "/brand",
            icon: faPalette,
            desc: "Logos, colors, and usage guidelines.",
          },
          {
            key: "change_log",
            title: "Change Log",
            heroDesc:
              "See how Simplifyte is evolving. Weekly updates and improvements.",
            heroTitle: "What's New",
            sub: "Latest features, improvements, and fixes.",
            to: "/changelog",
            icon: faHistory,
            desc: "Latest features, improvements, and fixes.",
          },
          {
            key: "security",
            title: "Security",
            sub: "Safe, secure, and private.",
            to: "/security",
            icon: faShieldAlt,
            desc: "Safe, secure, and private.",
          },
        ],
      },

      company: {
        kicker: "Company",
        title: "Explore Simplifyte",
        defaultDesc:
          "The story, the team, and the people building simpler work.",
        items: [
          {
            key: "about",
            title: "About",
            sub: "Why Simplifyte exists and what we’re building.",
            heroDesc: "What we believe in and what we’re solving",
            heroTitle: "Our story",
            to: "/about",
            icon: faCircleInfo,
            desc: "Why Simplifyte exists and what we’re building.",
          },
          {
            key: "careers",
            title: "Careers",
            sub: "Join the team shaping simpler workflows.",
            heroDesc: "Careers",
            heroTitle: "Careers",
            to: "/careers",
            icon: faBriefcase,
            desc: "Join the team shaping simpler workflows.",
          },
          // {
          //   key: "partner_program",
          //   title: "Partner Program",
          //   sub: "Collaborate, refer, or co-sell with us.",
          //   heroDesc: "Grow together—referrals, onboarding, implementations.",
          //   heroTitle: "Partner Program",
          //   to: "/partners",
          //   icon: faHandshake,
          //   desc: "Collaborate, refer, or co-sell with us.",
          // },
          // {
          //   key: "customers",
          //   title: "Customers",
          //   sub: "Case studies and success stories from top teams.",
          //   to: "/customers",
          //   icon: customers_icon,
          //   desc: "Case studies and success stories from top teams.",
          // },
        ],
      },
    }),
    [],
  );

  const isMegaOpen = !!activeMenu && isDesktop;

  // AOS init once
  useEffect(() => {
    AOS.init({
      duration: 420,
      easing: "ease-out-cubic",
      once: false,
      offset: 10,
    });
  }, []);

  // responsive
  useEffect(() => {
    const handleResize = () => setIsDesktop(window.innerWidth >= 992);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Always show navbar on initial load
  useEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
    setIsNavHidden(false);
  }, []);

  useEffect(() => {
    lastScrollY.current = window.scrollY;

    const onScroll = () => {
      if (rafId.current) cancelAnimationFrame(rafId.current);

      rafId.current = requestAnimationFrame(() => {
        const y = window.scrollY;
        const prev = lastScrollY.current;

        // keep your "scrolled" style
        setIsScrolled(y > 20);

        // if dropdown open OR mobile open -> don't hide navbar
        if (isMegaOpen || isMobileMenuOpen) {
          setIsNavHidden(false);
          lastScrollY.current = y;
          return;
        }

        const delta = y - prev;

        // ignore micro jitter
        if (Math.abs(delta) < 6) return;

        // if at top, always show
        if (y < 80) {
          setIsNavHidden(false);
          lastScrollY.current = y;
          return;
        }

        // down -> hide, up -> show
        if (delta > 0) setIsNavHidden(true);
        else setIsNavHidden(false);

        lastScrollY.current = y;
      });
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", onScroll);
      if (rafId.current) cancelAnimationFrame(rafId.current);
    };
  }, [isMegaOpen, isMobileMenuOpen]);

  // escape closes all
  useEffect(() => {
    const onKeyDown = (e) => {
      if (e.key === "Escape") {
        setActiveMenu(null);
        setDesc("");
        setIsMobileMenuOpen(false);
        setOpenCategory(null);
      }
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, []);

  // when mega opens → refresh AOS + replay blur entrance
  useEffect(() => {
    if (!isMegaOpen) return;
    setMenuOpenTick((t) => t + 1);

    const t = setTimeout(() => {
      AOS.refresh();
    }, 40);

    return () => clearTimeout(t);
  }, [isMegaOpen, activeMenu]);

  // when desc changes while open → animate desc
  useEffect(() => {
    if (!isMegaOpen) return;
    setDescTick((t) => t + 1);
  }, [desc, isMegaOpen]);

  const openMega = (menuKey) => {
    if (!isDesktop) return;

    if (closeT.current) clearTimeout(closeT.current);
    if (openT.current) clearTimeout(openT.current);

    openT.current = setTimeout(() => {
      setActiveMenu(menuKey);
    }, 70);
  };

  const closeMega = () => {
    if (!isDesktop) return;

    if (openT.current) clearTimeout(openT.current);
    if (closeT.current) clearTimeout(closeT.current);

    closeT.current = setTimeout(() => {
      setActiveMenu(null);
      setDesc("");
    }, 240);
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen((p) => !p);
    setActiveMenu(null);
    setDesc("");
  };

  const toggleCategory = (category) => {
    setOpenCategory((prev) => (prev === category ? null : category));
  };

  const currentMenu = activeMenu ? MENUS[activeMenu] : null;

  const handleHoverItem = (item) => {
    setTitleText(item?.heroTitle || item?.title || "");
    setHeroDesc(item?.heroDesc || item?.desc || "");
    setDesc(item?.desc || "");
  };

  const cancelClose = () => {
    if (closeT.current) clearTimeout(closeT.current);
  };

  // Reset left panel whenever menu changes
  useEffect(() => {
    if (!activeMenu) {
      setTitleText("");
      setHeroDesc("");
      setDesc("");
      return;
    }

    // when a new menu opens, show the menu defaults
    setTitleText("");
    setHeroDesc("");
    setDesc("");
  }, [activeMenu]);

  // Animate hero desc swap
  useEffect(() => {
    if (!isMegaOpen) return;
    setHeroDescTick((t) => t + 1);
  }, [heroDesc, isMegaOpen]);

  // Animate title swap
  useEffect(() => {
    if (!isMegaOpen) return;
    setTitleTick((t) => t + 1);
  }, [titleText, isMegaOpen]);

  const renderMenuIcon = (icon) => {
    if (!icon) return null;

    // ✅ FontAwesome
    if (typeof icon === "object" && icon.prefix && icon.iconName) {
      return <FontAwesomeIcon icon={icon} className="text-[#093A5B]" />;
    }

    // ✅ local svg/png/jpg url
    if (typeof icon === "string") {
      return (
        <img
          src={icon}
          alt=""
          width={20}
          height={20}
          className="filter-simplifyte-blue "
        />
      );
    }

    return null;
  };
  return (
    <div>
      <header
        // className={`sf-nav`}
        className={`sf-nav
        ${isScrolled ? "sf-nav--scrolled" : ""}
        ${isNavHidden ? "sf-nav--hidden" : ""}`}
      >
        <div
          className={`sf-nav__inner sf_jakarta  ${activeMenu !== null ? "!bg-white" : ""}`}
        >
          <div className={`sf-nav__row ${isMobileMenuOpen !== null ? "" : ""}`}>
            {/* Logo */}
            <div className="both-logo flex-shrink-0">
              {navClass === "nav-light" ? (
                <Link className="cu-logo" to="/">
                  <span className="inline-block dark:hidden">
                    <img
                      src={logo_dark}
                      className="l-dark"
                      height="24"
                      alt="Simplifyte"
                    />
                    <img
                      src={logo_light}
                      className="l-light"
                      height="24"
                      alt="Simplifyte"
                    />
                  </span>
                  {/* <img
                    src={logo_light}
                    height="24"
                    className="hidden dark:inline-block"
                    alt="Simplifyte"
                  /> */}
                </Link>
              ) : (
                <Link className="cu-logo" to="/">
                  <img
                    src={logo_dark}
                    className="inline-block dark:hidden"
                    alt="Simplifyte"
                  />
                  {/* <img
                    src={logo_light}
                    className="hidden dark:inline-block"
                    alt="Simplifyte"
                  /> */}
                </Link>
              )}
            </div>

            {/* Desktop nav */}
            {/* hover:shadow-[0_10px_30px_rgba(0,0,0,0.08)] */}
            <nav className={`${isDesktop ? "flex" : "hidden"} sf-nav__links `}>
              {/* <button
                type="button"
                className={`sf-nav__link companyli
                  rounded-full px-3 py-1
                  transition-all duration-300 ease-[cubic-bezier(.2,.9,.2,1)]
                  hover:bg-[#f1f3f5]
                  hover:ring-1 hover:ring-black/5
                  hover:-translate-y-[1px]
                  active:translate-y-0 
                  focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#093A5B]/25 ${activeMenu === "products" ? "is-open" : ""}`}
                onMouseEnter={() => openMega("products")}
                onMouseLeave={closeMega}
                onFocus={() => setActiveMenu("products")}
                onBlur={closeMega}
              >
                <span>Product</span>
                <FontAwesomeIcon
                  icon={faChevronDown}
                  className="sf-nav__chev"
                />
              </button> */}

              <Link
                to="/pricing"
                className="sf-nav__link  hover:bg-[#f1f3f5] hover:rounded-full transition-all delay-300 "
              >
                Pricing
              </Link>
              <button
                type="button"
                className={`sf-nav__link companyli
                  rounded-full px-3 py-1
                  transition-all duration-300 ease-[cubic-bezier(.2,.9,.2,1)]
                  hover:bg-[#f1f3f5]
                  hover:ring-1 hover:ring-black/5
                  hover:-translate-y-[1px]
                  active:translate-y-0 
                  focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#093A5B]/25
                  ${activeMenu === "resources" ? "bg-[#f1f3f5] ring-1 ring-black/5 is-open" : ""}
                `}
                // hover:shadow-[0_10px_30px_rgba(0,0,0,0.08)]
                onMouseEnter={() => openMega("resources")}
                onMouseLeave={closeMega}
                onFocus={() => setActiveMenu("resources")}
                onBlur={closeMega}
              >
                <span>Resources</span>
                <FontAwesomeIcon
                  icon={faChevronDown}
                  className="sf-nav__chev"
                />
              </button>

              <button
                type="button"
                className={`sf-nav__link companyli
                  rounded-full px-3 py-1
                  transition-all duration-300 ease-[cubic-bezier(.2,.9,.2,1)]
                  hover:bg-[#f1f3f5]
                  hover:ring-1 hover:ring-black/5
                  hover:-translate-y-[1px]
                  active:translate-y-0 
                  focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#093A5B]/25  ${activeMenu === "company" ? "is-open" : ""}`}
                // hover:shadow-[0_10px_30px_rgba(0,0,0,0.08)]
                onMouseEnter={() => openMega("company")}
                onMouseLeave={closeMega}
                onFocus={() => setActiveMenu("company")}
                onBlur={closeMega}
              >
                <span>Company</span>
                <FontAwesomeIcon
                  icon={faChevronDown}
                  className="sf-nav__chev"
                />
              </button>

              <Link
                to="/contact"
                className="sf-nav__link companyli
                  rounded-full px-3 py-1
                  transition-all duration-300 ease-[cubic-bezier(.2,.9,.2,1)]
                  hover:bg-[#f1f3f5]
                  hover:shadow-[0_10px_30px_rgba(0,0,0,0.08)]
                  hover:ring-1 hover:ring-black/5
                  hover:-translate-y-[1px]
                  active:translate-y-0 
                  focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#093A5B]/25"
              >
                Contact
              </Link>
            </nav>

            {/* CTA + mobile toggle */}
            <div className="sf-nav__actions">
              <div className="relative group inline-block">
                <Link
                  // to="/waitlist"
                  to="https://app.simplifyte.com/login"
                  className="ml-auto inline-flex items-center justify-center
              h-7 px-2.5 text-[11px] min-[480px]:h-9 min-[480px]:px-4 min-[480px]:text-[13px]
              rounded-full text-black font-medium
              hover:bg-[#0A466E] active:scale-[0.98]
              focus:outline-none focus-visible:ring-2 focus-visible:ring-[#093A5B]/40 focus-visible:ring-offset-2
              transition border-2 border-[#f2f2f2] hover:text-white py-1 custom-padding"
                >
                  {/* Join Waitlist */}
                  Login
                </Link>
              </div>
              <div className="relative group inline-block">
                <Link
                  to="https://app.simplifyte.com/login"
                  className="ml-auto inline-flex items-center justify-center
              h-7 px-2.5 text-[11px] min-[480px]:h-9 min-[480px]:px-4 min-[480px]:text-[13px]
              rounded-full text-white font-medium
              bg-[#093A5B] hover:bg-[#0A466E] active:scale-[0.98]
              focus:outline-none focus-visible:ring-2 focus-visible:ring-[#093A5B]/40 focus-visible:ring-offset-2
              transition border-2 border-transparent py-1 custom-padding"
                >
                  Get Started
                </Link>
              </div>

              {!isDesktop && (
                <button
                  type="button"
                  className={`sf-mobileToggle ${isMobileMenuOpen ? "is-open" : ""}`}
                  onClick={toggleMobileMenu}
                  aria-label="Open menu"
                  aria-expanded={isMobileMenuOpen}
                >
                  {isMobileMenuOpen ? (
                    <X className="w-5 h-5" />
                  ) : (
                    <Menu className="w-5 h-5" />
                  )}
                </button>
              )}
            </div>
          </div>

          {/* ✅ Mobile menu (only mobile) */}
          {!isDesktop && (
            <div
              className={`sf-mobile ${isMobileMenuOpen ? "sf-mobile--open " : ""}`}
            >
              <nav className={`sf-mobile__nav ${isMobileMenuOpen ? "" : ""}`}>
                {/* "products", */}
                {["resources", "company"].map((key) => (
                  <div key={key}>
                    <button
                      type="button"
                      onClick={() => toggleCategory(key)}
                      className="sf-mobile__item"
                    >
                      <span style={{ textTransform: "capitalize" }}>{key}</span>
                      {openCategory === key ? (
                        <FaChevronUp color="rgba(22, 28, 45 , 0.5)" />
                      ) : (
                        <FaChevronDown color="rgba(22, 28, 45 , 0.5)" />
                      )}
                    </button>

                    <div
                      className={`sf-mobile__sub ${openCategory === key ? "is-open" : ""}`}
                    >
                      {MENUS[key].items.map((it) => (
                        <Link key={it.key} to={it.to}>
                          {it.title}
                        </Link>
                      ))}
                    </div>
                  </div>
                ))}

                <Link to="/pricing" className="sf-mobile__link">
                  Pricing
                </Link>
                <Link to="/contact" className="sf-mobile__link">
                  Contact
                </Link>
              </nav>
            </div>
          )}
        </div>

        {/* ✅ FULL WIDTH DROPDOWN */}
        <div
          className={`sf-mega rounded-b-[20px] ${isMegaOpen ? "sf-mega--open" : ""}`}
          onMouseEnter={cancelClose}
          onMouseLeave={closeMega}
        >
          <div className="sf-mega__bridge" />

          <div className="sf-mega__sheet">
            {/* key = menuOpenTick to replay blur entrance */}
            <div className="sf-mega__inner" key={menuOpenTick}>
              <div
                className="sf-mega__grid rounded-b-[20px] sf-reveal"
                onMouseLeave={() => {
                  setTitleText("");
                  setHeroDesc("");
                  setDesc("");
                }}
              >
                {/* Left */}
                <div className="sf-mega__left">
                  <div className="sf-leftOnly" aria-live="polite">
                    <div
                      className="sf-leftOnly__kicker"
                      data-aos="fade-up"
                      data-aos-delay="0"
                    >
                      {currentMenu?.kicker || ""}
                    </div>

                    <div
                      className="sf-leftOnly__titleWrap"
                      data-aos="fade-up"
                      data-aos-delay="80"
                    >
                      <div className="sf-leftOnly__title">
                        <div className="sf-leftOnly__title">
                          <span
                            key={titleTick}
                            className="sf-leftOnly__titleText"
                          >
                            {titleText || currentMenu?.title || ""}
                          </span>
                        </div>
                      </div>
                    </div>

                    <div
                      className="sf-leftOnly__descStage"
                      data-aos="fade-up"
                      data-aos-delay="140"
                    >
                      <div key={heroDescTick} className="sf-leftOnly__descText">
                        {heroDesc || currentMenu?.defaultDesc || ""}
                      </div>
                    </div>
                  </div>
                </div>

                {/* Center: 2 columns */}
                <div
                  className="sf-mega__center"
                  data-aos="fade-up"
                  data-aos-delay="60"
                >
                  <div className="sf-centerGrid">
                    {(currentMenu?.items || []).map((it, idx) => (
                      <Link
                        key={it.key}
                        to={it.to}
                        className="sf-centerItem"
                        onMouseEnter={() => handleHoverItem(it)}
                        data-aos="fade-up"
                        data-aos-delay={80 + idx * 45} // ✅ stagger
                        data-aos-duration="420"
                      >
                        <span className="sf-centerItem__vline" />
                        <div className="sf-centerItem__icon border">
                          {renderMenuIcon(it.icon)}
                        </div>

                        <div className="sf-centerItem__body">
                          <div className="sf-centerItem__title">
                            {it.title}
                            {/* {console.log("{it.title}", it.title)} */}
                          </div>
                          <div className="sf-centerItem__sub">{it.sub}</div>
                        </div>

                        <div className="sf-centerItem__chev">
                          <ChevronRight className="w-4" />
                        </div>

                        <span className="sf-centerItem__glow" />
                      </Link>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Overlay */}
      </header>
      <div
        className={`sf-overlay ${isMegaOpen || isMobileMenuOpen ? "sf-overlay--open" : ""}`}
        onClick={() => {
          setActiveMenu(null);
          setIsMobileMenuOpen(false);
          setDesc("");
          setOpenCategory(null);
        }}
      />

      <div className="sf-nav__spacer" />
    </div>
  );
};

export default HeaderMenu;
